import useFirestoreMessages from "./useFirestoreMessages";

// Realtime message source. As of M6 the Socket.IO path is decommissioned; displays
// read exclusively from Firestore. Returns { messages, setMessages, apiMessages,
// setApiMessages }. See REVISED-ARCHITECTURE.md §6.
export default function useMessages({ viewerId }) {
  return useFirestoreMessages({ viewerId, enabled: true });
}
